import React from 'react';
import { NextPage } from 'next';
import Head from 'next/head';
import { defineMessages, useIntl } from 'react-intl';
import { Footer } from '../../../layouts/Footer';
import { Category } from './categories/types';
import { CategoriesTop } from './categories/CategoriesTop';
import { CategoriesList } from './categories/CategoriesList';
import { IndexDownloadNow } from '../index/IndexDownloadNow';

const { pageTitle } = defineMessages({
  pageTitle: {
    id: 'web.categories.page_title',
    defaultMessage: 'Categories'
  }
});

export const CategoriesPage: NextPage<{ categories: Category[] }> = React.memo(({ categories }) => {
  const intl = useIntl();
  const description = intl.formatMessage({
    id: 'web.categories.page_description',
    defaultMessage: 'List of all Quizado categories'
  });
  return (
    <>
      <Head>
        <title>{intl.formatMessage(pageTitle)}</title>
        <meta itemProp="description" content={description} key="itemProp-description" />
        <meta name="description" content={description} key="description" />
        <meta property="og:description" content={description} key="fb-description" />
        <meta property="twitter:description" content={description} key="twitter-description" />
      </Head>
      <CategoriesTop />
      <CategoriesList categories={categories} />
      <IndexDownloadNow />
      <Footer />
    </>
  );
});
